module.exports = __webpack_public_path__ + "img/c3537cbceb94cc2f92202d4df9e5722e.da7030c4.png";